import React from 'react'
import './Faq.scss';
import Accordion from 'react-bootstrap/Accordion'

function Faq() {
    return (
        <div id="faq">
            <h1>Frequently asked questions.</h1> 
                <Accordion>
                    <Accordion.Item eventKey="0">
                        <Accordion.Header>Lorem ipsum dolor sit amet, consectetur adipiscing</Accordion.Header>
                        <Accordion.Body>
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Laboriosam velit itaque explicabo sunt ducimus. Cupiditate repellendus nemo iusto provident perspiciatis dolor, voluptate quidem tenetur labore cum id! Nihil, doloremque excepturi?
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="1">
                        <Accordion.Header>Lorem ipsum dolor sit amet, consectetur adipiscing</Accordion.Header>
                        <Accordion.Body>
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Laboriosam velit itaque explicabo sunt ducimus. Cupiditate repellendus nemo iusto provident perspiciatis dolor, voluptate quidem tenetur labore cum id! Nihil, doloremque excepturi?
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="2">
                        <Accordion.Header>Lorem ipsum dolor sit amet, consectetur adipiscing</Accordion.Header>
                        <Accordion.Body>
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Laboriosam velit itaque explicabo sunt ducimus. Cupiditate repellendus nemo iusto provident perspiciatis dolor, voluptate quidem tenetur labore cum id! Nihil, doloremque excepturi?
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="3">
                        <Accordion.Header>Lorem ipsum dolor sit amet, consectetur adipiscing</Accordion.Header>
                        <Accordion.Body>
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Laboriosam velit itaque explicabo sunt ducimus. Cupiditate repellendus nemo iusto provident perspiciatis dolor, voluptate quidem tenetur labore cum id! Nihil, doloremque excepturi?
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="4">
                        <Accordion.Header>Lorem ipsum dolor sit amet, consectetur adipiscing</Accordion.Header>
                        <Accordion.Body>
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Laboriosam velit itaque explicabo sunt ducimus. Cupiditate repellendus nemo iusto provident perspiciatis dolor, voluptate quidem tenetur labore cum id! Nihil, doloremque excepturi?
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
        </div>
    )
}

export default Faq
